export default {
  menu: {
    'user-profile': 'Profile',
    'security-center': 'Security Center',
    'withdrawal-method': 'Withdrawal Method',
  },
  common: {
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add Account',
    'operation-failed': 'Operation Failed',
  },
  profile: {
    edit: 'Edit',
    set: 'Set',
    title: 'Profile',
    user_id: 'User ID',
    create_time: 'Registration Time',
    account_status: 'Account Status',
    account_status_value: {
      normal: 'Normal',
      frozen: 'Frozen',
      suspended: 'Suspended',
    },
    version: 'Version',
    biography: {
      title: 'Biography',
      placeholder: 'Please enter your biography',
      button: {
        edit: 'Edit',
        set: 'Set',
      },
    },
    kyc_status: {
      authenticated: 'Authenticated',
      unauthenticated: 'Unauthenticated',
    },
    copy: {
      success: 'User ID copied',
      failed: 'Copy failed',
    },
    'user-profile': {
      'modal-title': 'Update Nickname',
      nickname: 'Nickname',
      'nickname-required': 'Please enter nickname',
    },
  },
  security: {
    title: 'Security Center',
    phone: {
      label: 'Phone',
      update: 'Update',
      set: 'Set',
      upset: 'Unset',
      modal: {
        title: 'Update Phone',
      },
    },
    email: {
      label: 'Email',
      update: 'Update',
      set: 'Set',
      unset: 'Unset',
      modal: {
        title: 'Update Email',
      },
    },
    loginPassword: {
      label: 'Login Password',
      update: 'Update',
      set: 'Set',
      unset: 'Unset',
      modal: {
        title: 'Update Login Password',
      },
    },
    fundPassword: {
      label: 'Fund Password',
      update: 'Update',
      set: 'Set',
      unset: 'Unset',
      modal: {
        title: 'Update Fund Password',
      },
    },
    passkey: {
      label: 'Passkey (Biometric)',
      update: 'Manage',
      set: 'Set',
      unset: 'Unset',
      modal: {
        title: 'Add Passkey',
      },
      description: 'Use Apple Passkey, Google Passkey to protect your account security.',
    },
    authenticator: {
      label: 'Authenticator APP',
      update: 'Manage',
      set: 'Set',
      unset: 'Unset',
      modal: {
        title: 'Bind Authenticator APP',
      },
      description:
        'Use Google Authenticator / Microsoft Authenticator to protect your account security.',
    },
    logs: {
      label: 'Account Logs',
      update: 'View',
    },
    device: {
      label: 'Device Management',
      update: 'View',
    },
    passkeyPage: {
      title: 'Passkey (Biometric)',
      add: 'Add Passkey',
      description: 'Use Apple Passkey, Google Passkey to protect your account security.',
      list: {
        name: 'Name',
        platform: 'Platform',
        is_cloud: 'Cross-device',
        is_local: 'Local',
        create_time: 'Add Time',
        last_time: 'Last Time',
        action: {
          rename: 'Rename',
          reset: 'Reset Key',
        },
      },
      modal: {
        reset: {
          title: 'Reset Key',
          content:
            'Are you sure you want to reset this passkey? You will need to add it again on your device after reset.',
        },
      },
      message: {
        browserNotSupported: 'This browser does not support passkeys',
        getParamsFailed: 'Failed to get passkey parameters',
        getResetParamsFailed: 'Failed to get reset parameters',
        addSuccess: 'Passkey added successfully',
        resetSuccess: 'Key reset successfully',
        addFailed: 'Failed to add passkey',
        resetFailed: 'Failed to reset key',
        securityError:
          'rp.id does not match current domain: use localhost for local development; configure /.well-known/webauthn for cross-domain',
        cancelled: 'Passkey creation cancelled',
      },
    },
    authenticatorPage: {
      title: 'Authenticator APP',
      modal: {
        title: 'Bind Authenticator APP',
      },
      downloadAppTitle: 'Download Authenticator App',
      ios: {
        title: 'iOS Users',
        desc: 'Go to the App Store and search for “Google Authenticator & Microsoft Authenticator” to download.',
      },
      android: {
        title: 'Android Users',
        desc: 'Go to Google Play and search for “Google Authenticator & Microsoft Authenticator” to download.',
      },
      qrcode: {
        google: 'Google',
        microsoft: 'Microsoft',
      },
      step1: {
        title: 'Account Security Verification',
        continue: 'Continue',
      },
      step2: {
        title: 'Bind Authenticator App',
        instructionsTitle: 'Add key in the Authenticator app and back it up',
        instructionsDesc:
          'Open the Authenticator app and scan the QR code below or manually enter the account and key below to add.',
        warning:
          'The secret key is used to recover Google Authenticator when your phone is replaced or lost. Please make sure to back up the secret key below before binding.',
        labels: {
          accountName: 'Account Name',
          secret: 'Secret',
        },
        continue: 'Confirm',
      },
      code: {
        label: 'Authenticator App Code',
      },
      actions: {
        prev: 'Previous',
        confirm: 'Confirm',
      },
      message: {
        copySuccess: 'Copied',
        copyFailed: 'Copy failed',
        bindSuccess: 'Binding successful',
      },
    },
    deviceManage: {
      title: 'Device Management',
      table: {
        columns: {
          loginStatus: 'Login Status',
          device: 'Login Device',
          ip: 'IP Address',
          region: 'Region',
          lastLoginTime: 'Last Login Time',
          device_id: 'Device UUID',
          action: 'Action',
        },
        enum: {
          loginStatus: {
            login: 'Logged In',
            logout: 'Logged Out',
          },
          action: {
            currentDevice: 'Current Device',
          },
        },
      },
      button: {
        logout: 'Logout',
      },
    },
    withdrawalMethodPage: {
      title: 'Withdrawal Method',
      bank: {
        label: 'Bank',
        update: 'Update',
      },
    },
    logsPage: {
      title: 'Account Logs',
      tabs: {
        login: 'Login Logs',
        operate: 'Operation Logs',
      },
      login: {
        table: {
          columns: {
            create_time: 'Login Time',
            platform: 'Login Terminal',
            ip: 'IP Address',
            region: 'Location',
            device: 'Login Device',
            device_id: 'Device UUID',
            type: 'Client',
            version: 'Version',
            login_status: 'Login Status',
            enum: {
              login_status: {
                success: 'Success',
                failed: 'Failed',
              },
            },
            remarks: 'Remarks',
          },
        },
      },
      operate: {
        table: {
          columns: {
            create_time: 'Operate Time',
            activity_type: 'Operation Type',
            platform: 'Platform',
            ip: 'IP Address',
            region: 'Location',
            agent: 'Device',
            device_id: 'Device UUID',
            login_status: 'Login Status',
            remarks: 'Remark',
            enum: {
              login_status: {
                success: 'Success',
                failed: 'Failed',
              },
            },
          },
        },
      },
    },
  },
  withdraw: {
    title: 'Withdrawal Method',
    crypto: {
      title: 'Cryptocurrency Wallet',
    },
    bank: {
      title: 'Bank Transfer',
    },
    international: {
      title: 'International Wire Transfer',
    },
    modal: {
      add: {
        title: 'Add Withdrawal Account',
      },
      update: {
        title: 'Update Withdrawal Account',
      },
      delete: {
        title: 'Delete Withdrawal Account',
      },
    },
    forms: {
      common: {
        labels: {
          emailCode: 'Email Verification Code',
          securityType: 'Security Verification Method',
          securityCode: 'Verification Code',
        },
        buttons: {
          confirmAdd: 'Confirm Add',
        },
        messages: {
          submitFailed: 'Submit failed, please check the form',
        },
      },
      usdt: {
        labels: {
          address: 'Address',
        },
        messages: {
          success: 'USDT submitted successfully',
        },
      },
      bank: {
        labels: {
          cardHolderName: 'Cardholder Name',
          bankName: 'Bank Name',
          bankCardNumber: 'Bank Card No',
          swiftCode: 'Swift Code',
          checked: 'You are adding a new bank card, you need to agree to Credit/Debit Card Terms.',
        },
        messages: {
          success: 'Bank card submitted successfully',
        },
      },
      international: {
        labels: {
          cardHolderName: 'Cardholder Name',
          bankName: 'Bank Name',
          bankCardNumber: 'Bank Card No',
          swiftCode: 'Swift Code',
          checked: 'You are adding a new bank card, you need to agree to Credit/Debit Card Terms.',
        },
        messages: {
          success: 'International bank account submitted successfully',
        },
      },
    },
  },
  ibSignature: {
    title: 'IB Agreement Signing',
    breadcrumb: {
      home: 'Home',
      ibSignature: 'IB Agreement Signing',
    },
    checkbox: {
      text: 'I confirm that I have carefully read all the above terms and conditions and Risk Acknowledgement And Disclosure, and guarantee that the information provided is true and valid. I agree to sign a legally binding contract and bear corresponding legal responsibilities. I understand and agree that this electronic signature is equivalent to a handwritten signature.',
    },
    button: {
      readRemaining: 'Please scroll down to read the entire agreement ({time})',
      readComplete: 'Please scroll down to read the entire agreement',
      confirmSignature: 'Confirm Signature',
    },
    modal: {
      title: 'Please Sign',
      button: {
        rewrite: 'Rewrite',
        cancel: 'Cancel',
        submit: 'Submit',
      },
    },
    messages: {
      uploadFailed: 'Failed to upload signature',
    },
  },
}
